import { motion } from 'framer-motion';
import { useContext } from 'react';
import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import { TabsContext } from './TabsContext';
import Tooltip from 'Components/Molecules/Tooltip/Tooltip';

export default function IconTab(props) {
    const { value, className, icon, tooltip } = props;
    const { activeTab, setActiveTab, disabledTransition } = useContext(TabsContext);

    const button = (
        <button
            type="button"
            onClick={() => setActiveTab(value)}
            className={cn(
                'flex items-center justify-center relative h-full aspect-square',
                activeTab === value ? 'font-semibold text-dark-blue' : 'text-dark-blue/50',
                className,
            )}
        >
            {activeTab === value && (
                <motion.span
                    layoutId={disabledTransition ? undefined : 'icon-tab-bubble'}
                    className="absolute inset-0 bg-white rounded-md shadow-md"
                    transition={disabledTransition ? { duration: 0 } : { type: 'spring', bounce: 0.2, duration: 0.4 }}
                />
            )}

            <div className="relative">{icon}</div>
        </button>
    );

    if (tooltip) {
        return (
            <Tooltip label={tooltip} placement="top">
                {button}
            </Tooltip>
        );
    }

    return button;
}

IconTab.propTypes = {
    value: PropTypes.string.isRequired,
    className: PropTypes.string,
    icon: PropTypes.node,
    tooltip: PropTypes.string,
};
